import { type SugarProviderPhoto } from '@app/types'

// Constructs the URL for fetching the raw image bytes for a server-side photo.
// Resolves to the Next.js proxy route at /api/provider-profile/photos/{id}/raw,
// which forwards to the backend's /MetrixEnroll/provider-profile/photos/{id}/raw
// content-streaming endpoint (Active + Under Review photos render; invalid /
// Removed return 404). The browser caches via the backend's ETag + 5-minute
// max-age headers; conditional GET (If-None-Match) is forwarded through.
export const photoImageUrl = (photo: SugarProviderPhoto): string =>
  `/api/provider-profile/photos/${photo.id}/raw?siteId=${encodeURIComponent(photo.siteId)}`
